import { useMutation, useQueryClient } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IApplianceManufacturer } from './../../types/Appliance/ApplianceManufacturer';
import { useDefaultMutateResponseHandlers } from '../../hooks/useDefaultMutateResponeHandlers';

export default function useApplianceManufacturerMutations() {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();
  const { handleSuccess, handleError } = useDefaultMutateResponseHandlers(
    'Appliance Manufacturer'
  );

  const createApplianceManufacturer = useMutation({
    mutationFn: (applianceManufacturer: IApplianceManufacturer) =>
      post('/v1/superadmin/hardware/manufacturers', applianceManufacturer),
    onError: (error) => handleError(error, 'create'),
    onSuccess: (data) => handleSuccess(data, 'create'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.manufacturers());
      queryClient.invalidateQueries(
        applianceQueryKeys.superAdminManufacturers()
      );
    },
  });

  const updateApplianceManufacturer = useMutation({
    mutationFn: (applianceManufacturer: IApplianceManufacturer) =>
      put(
        `/v1/superadmin/hardware/manufacturers/${applianceManufacturer.id}`,
        applianceManufacturer
      ),
    onError: (error) => handleError(error, 'update'),
    onSuccess: (data) => handleSuccess(data, 'update'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.manufacturers());
      queryClient.invalidateQueries(
        applianceQueryKeys.superAdminManufacturers()
      );
    },
  });

  const delApplianceManufacturer = useMutation({
    mutationFn: (applianceManufacturer: IApplianceManufacturer) =>
      del(`/v1/superadmin/hardware/manufacturers/${applianceManufacturer.id}`),
    onError: (error) => handleError(error, 'delete'),
    onSuccess: (data) => handleSuccess(data, 'delete'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.manufacturers());
      queryClient.invalidateQueries(
        applianceQueryKeys.superAdminManufacturers()
      );
    },
  });

  return {
    createApplianceManufacturer,
    updateApplianceManufacturer,
    delApplianceManufacturer,
  };
}
